import styled from 'styled-components';

import { InputStyled } from '../../inputs';

const Container = styled.div`
  width: 310px;
  height: 60px;
  display: flex;
  align-items: center;
`;

const MenuSelectIconsContainer = styled.div`
  padding-right: 10px;

`;

const InputContainer = styled.div`
  height: 100%;

  ${InputStyled.InputContainer} {
    width: ${(p) => (p.isIcon ? '240px' : '310px')};
  }
`;

export const Styled = {
  Container,
  MenuSelectIconsContainer,
  InputContainer,
};
